import React, { Component } from 'react'
import EntityList from './../components/entityList';

import utils from './../misc/utils';
var config = utils.getConfig();

class InventoryByMakeReport extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {};
  }

  componentDidMount(){
    utils.getDataFromApi('api/makes/' + this.props.params.makeid, data => {
      this.setState({makeDescription: data.Description})
    });
  }

  render() {
    return (
      <EntityList apiRoute='api/trailers' baseCriteria={`count=1000&scope=active&MakeID=${this.props.params.makeid}`} title={'Inventaire ' + this.state.makeDescription} allowEdit={false} allowAdd={false} allowDelete={false} displayColumns={[
        {Description: 'No. inventaire', Column: 'ProductNumber'},
        {Description: 'No. modèle', Column: 'ModelNumber'},
        {Description: 'Modèle', Column: 'TrailerModel', format: {type: 'relation', displayColumn: 'Description'}},
        {Description: 'Année', Column: 'Year'},
        {Description: 'Coûtant', Column: 'Cost', format: {type: 'money'}},
        {Description: 'Transport', Column: 'TransportCost', format: {type: 'money'}},
        {Description: 'Taux de change', Column: 'ExchangeRate', format: {type: 'money'}},
        {Description: 'Prix', Column: 'Price', format: {type: 'money'}},
        {Description: 'Profit', Column: '', format: {type: 'money', calculation: 'entity.Price - (entity.Cost + entity.TransportCost + entity.ExchangeRate)'}},
      ]}/>
    )
  }
}

export default InventoryByMakeReport;


/** WEBPACK FOOTER **
 ** ./src/app/reports/inventoryByMake.js
 **/